import React, { useState } from "react";
import { Link } from "react-router-dom";
import { X } from "@phosphor-icons/react";
import { rememberLanguage } from "../../components/ui/LanguageToggle";
import { answerLanguageSuggestion, languageSuggestionAnswered, suggestedLanguage } from "../../i18n/languageSuggestion";
import useHydrated from "../../rendering/useHydrated";
import { localizedPath } from "../../utils/seoLinks";
import "./languageSuggestion.css";

// In the language it suggests, which the visitor reads.
const WORDS = {
  en: { label: "Language", say: "This page is also in English.", go: "Read in English", close: "Dismiss" },
  it: { label: "Lingua", say: "Questa pagina c'è anche in italiano.", go: "Leggi in italiano", close: "Chiudi" },
};

// The page the visitor is on (`page`, in `lang`), suggested in the language
// their browser reads, until they take it, dismiss it or pick a language in
// the header. Only in the browser: the built page, which search engines
// read, is the same for every visitor.
export default function LanguageSuggestion({ lang, page }) {
  const hydrated = useHydrated();
  const [answered, setAnswered] = useState(false);
  if (!hydrated || answered || languageSuggestionAnswered()) return null;
  const suggested = suggestedLanguage(navigator.languages, lang);
  if (!suggested) return null;
  const words = WORDS[suggested];

  return (
    <aside className="ls" lang={suggested} aria-label={words.label}>
      <p>{words.say}</p>
      <Link className="btn btn-gold" to={localizedPath(page, suggested)} hrefLang={suggested} onClick={() => rememberLanguage(lang, suggested)}>
        {words.go}
      </Link>
      <button
        type="button"
        className="ls-close"
        aria-label={words.close}
        onClick={() => {
          answerLanguageSuggestion();
          setAnswered(true);
        }}
      >
        <X aria-hidden="true" />
      </button>
    </aside>
  );
}
